import { Box, Stack, Typography, Button, Chip } from "@mui/material";


const InventoryGrid = ({
  room,
  daysOfMonth,
  startIndex,
  daysPerPage,
  selectedDays,
  setSelectedDays,
  editType,
  setEditType,
  editModeRoom,
  setEditModeRoom,
  isSelecting,
  setIsSelecting,
  selectionStart,
  setSelectionStart,

}) => {
const labelStyle = {
  backgroundColor: "#F8FAFC",
  borderRight: "1px solid #E2E8F0",
  borderBottom: "1px solid #E2E8F0",
  px: 2,
  py: 2,
  fontWeight: 600,
  fontSize: 14,
};

const cellStyle = {
  borderLeft: "1px solid #E2E8F0",
  borderBottom: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 48,
  fontSize: 14,
  transition: "all 0.15s ease",
  "&:hover": {
  backgroundColor: "#EEF2FF",
  
}
};


  return (
  <Box
    sx={{
      border: "1px solid #E2E8F0",
      borderRadius: 3,
      overflow: "hidden",
      mb: 5,
    }}
  >
    {/* ROOM HEADER */}
    <Box
      sx={{
        backgroundColor: "#F8FAFC",
        px: 3,
        py: 2,
        borderBottom: "1px solid #E2E8F0",
        fontWeight: 600,
      }}
    >
      {room.title}
    </Box>

    {/* GRID */}
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `120px repeat(${daysPerPage}, 1fr)`,
        userSelect: "none",
  }}
>
      {/* ================= TARIF ROW ================= */}
      <Box sx={labelStyle}>Tarif (€)</Box>

      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const price = dayData?.price ?? room.price
          const locked = dayData?.locked ?? false

         
          const isSelected = (selectedDays[editType] || []).includes(index);

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {

                if (locked) return;

                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("tarif");

                setSelectedDays({
                  tarif: [index],
                  inventory: [],
                  status: [],
                });

              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "tarif" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: range,
                    inventory: [],
                    status: [],
                  });
                  
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: locked ? "not-allowed" : "pointer",                
                backgroundColor:
                  locked ? "#F1F5F9" :
                  selectedDays.tarif.includes(index) &&
                  editType === "tarif" &&
                  editModeRoom === room.roomId
                    ? "#4F46E5"
                    : price === 0
                    ? "#FEE2E2"
                    : "#FFFFFF",
                color:
                  selectedDays.tarif.includes(index) &&
                  editType === "tarif" &&
                  editModeRoom === room.roomId
                    ? "white"
                    : "inherit",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {price}
            </Box>
          );
        })}

      {/* ================= STOCK ROW ================= */}
      <Box sx={labelStyle}>Stock</Box>

      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const available = dayData?.inventory ?? 0
          const isSelected = (selectedDays[editType] || []).includes(index);

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {
                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("inventory");

                setSelectedDays({
                  tarif: [],
                  inventory: [index],
                  status: [],
                });
              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: [],
                    inventory: range,
                    status: [],
                  });
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: "pointer",
                backgroundColor:
                  selectedDays.inventory.includes(index) &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId
                    ? "#4F46E5"
                    : available === 0
                    ? "#FEE2E2"
                    : "#FFFFFF",
                color:
                  selectedDays.inventory.includes(index) &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId
                    ? "white"
                    : "inherit",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {available}
            </Box>
          );
        })}

      {/* ================= STATUS ROW ================= */}
      <Box sx={labelStyle}>Statut</Box>

      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const status = dayData?.status ?? "opened"
          const isClosed = status === "closed";
          const isSelected = (selectedDays[editType] || []).includes(index);

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {
                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("status");

                setSelectedDays({
                  tarif: [],
                  inventory: [],
                  status: [index],
                });
              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "status" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: [],
                    inventory: [],
                    status: range,
                  });
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: "pointer",
                fontWeight: 600,
                backgroundColor:
                  selectedDays.status.includes(index) &&
                  editType === "status" &&
                  editModeRoom === room.roomId
                    ? "#4F46E5"
                    : isClosed
                    ? "#F1F5F9"
                    : "#DCFCE7",
                color:
                  selectedDays.status.includes(index) &&
                  editType === "status" &&
                  editModeRoom === room.roomId
                    ? "white"
                    : isClosed
                    ? "#475569"
                    : "#166534",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {isClosed ? "F" : "O"}
            </Box>
          );
        })}
    </Box>
  </Box>
);
};

export default InventoryGrid;